import {
  Alert,
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Grid,
  Snackbar,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import { getData, postData } from "../../../../services/library";
import moment from "moment";

function AsignarHojaRuta({ open, onClose, username }) {
  const [choferes, setChoferes] = useState();
  const [hojaRuta, setHojaRuta] = useState();
  const [choferSeleccionado, setChoferSeleccionado] = useState("");
  const [hojaSeleccionada, setHojaSeleccionada] = useState("");
  const [uuidRendicion, setUuidRendicion] = useState(uuidv4());
  const [rendicion, setRendicion] = useState([]);
  const [checked, setChecked] = useState(false);
  const [repartoTarde, setRepartoTarde] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [datos, setDatos] = useState({
    fecha_para: moment(new Date()).format("YYYY-MM-DD"),
  });
  const [notificacion, setNotificacion] = useState({
    open: false,
    mensaje: "",
    severity: "",
    color: "",
  });
  const [mostrarAdvertencia, setMostrarAdvertencia] = useState(false);

  useEffect(() => {
    getData(
      "/envasado_hoja_ruta/xsucauth/" +
        localStorage.getItem("suc_auth").split(","),
      setHojaRuta,
    );
    getData(
      "/choferes/envasadoxsucauth/" + localStorage.getItem("suc_auth").split(","),
      setChoferes,
    );
  }, []);

  const obtenerRendicion = () => {
    getData(
      "/envasado_rendiciones/choferxfechaxtarde/" +
        choferSeleccionado.id +
        "/" +
        moment(datos.fecha_para, "YYYY-MM-DD").format("YYYY-MM-DD") +
        "/" +
        repartoTarde,
      setRendicion,
    );
  };

  useEffect(() => {
    if (Object.keys(choferSeleccionado).length !== 0) {
      setIsLoading(true);
      try {
        obtenerRendicion();
      } catch {
        console.error("Error");
      } finally {
        setIsLoading(false);
      }
    }
  }, [choferSeleccionado, repartoTarde, datos.fecha_para]);

  useEffect(() => {
    if (rendicion.length > 0 && Object.keys(choferSeleccionado).length !== 0) {
      setMostrarAdvertencia(true);
    } else {
      setMostrarAdvertencia(false);
    }
  }, [rendicion, choferSeleccionado]);

  const handleChangeChecked = (event) => {
    setChecked(event.target.checked);
  };

  useEffect(() => {
    if (checked === true) {
      setRepartoTarde(1);
    } else {
      setRepartoTarde(0);
    }
  }, [checked]);

  async function guardarChoferAsignado(e) {
    if (rendicion.length === 0) {
      try {
        await postData(
          e,
          "/envasado_rendiciones/",
          {
            fecha: moment(datos.fecha_para).format("YYYY-MM-DD"),
            chofer: choferSeleccionado.id,
            uuid: uuidRendicion,
            estado: 272,
            hoja_ruta: hojaSeleccionada.id,
            activo:1,
            sucursal:choferSeleccionado.id_sucursal
          },
          setNotificacion,
        );

        setNotificacion({
          open: true,
          mensaje: "Rendición asignada con éxito",
          severity: "success",
        });

        onClose();
      } catch (error) {
        console.error(error);
        setNotificacion({
          open: true,
          mensaje: "Ocurrió un error al guardar",
          severity: "error",
        });
      }
    }
  }

  const almacenar = (e) => {
    setDatos({
      ...datos,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <>
      <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
        <Box justifyContent="center" backgroundColor="#1F618D">
          <DialogTitle>
            <Typography fontSize={20} align="center" color="#ffffff">
              Asignar Rendición - Hoja de Ruta
            </Typography>
          </DialogTitle>
        </Box>
        <DialogContent>
          <Grid container spacing={1}>
            {mostrarAdvertencia === true ? (
              <Grid
                item
                xs={12}
                style={{
                  backgroundColor: "#fff9c4",
                  fontWeight: "bold",
                  textAlign: "center",
                  padding: "8px",
                }}
              >
                <label>
                  El chofer {choferSeleccionado.nombre_apellido} ya tiene
                  asignada una rendición en el día{" "}
                  {moment(datos.fecha_para, "YYYY-MM-DD").format("DD-MM-YYYY")}
                </label>
              </Grid>
            ) : null}
            <Grid item xs={6}>
              <Autocomplete
                disabled={!hojaRuta}
                required
                disableClearable
                id="hoja"
                size="small"
                noOptionsText={"hoja de Ruta INEXISTENTE"}
                options={hojaRuta}
                autoHighlight
                getOptionLabel={(hoja) => hoja.id + "-" + hoja.nombre}
                onChange={(event, value) => {
                  setHojaSeleccionada(value);
                  setIsLoading(true);
                }}
                renderOption={(props, option) => (
                  <Box
                    component="li"
                    key={option.id}
                    sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                    {...props}
                  >
                    {option.id} - {option.nombre}
                  </Box>
                )}
                renderInput={(params) => (
                  <TextField
                    placeholder="Tipee para buscar..."
                    {...params}
                    label="Hoja de Ruta"
                    focused
                    inputProps={{
                      ...params.inputProps,
                    }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={6}>
              <Autocomplete
                disabled={!choferes}
                required
                disableClearable
                id="chofer"
                size="small"
                noOptionsText={"Chofer INEXISTENTE"}
                options={choferes}
                autoHighlight
                getOptionLabel={(chofer) =>
                  chofer.id + "-" + chofer.nombre_apellido
                }
                onChange={(event, value) => {
                  setChoferSeleccionado(value);
                  setIsLoading(true);
                }}
                renderOption={(props, option) => (
                  <Box
                    component="li"
                    key={option.id}
                    sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                    {...props}
                  >
                    {option.id} - {option.nombre_apellido}
                  </Box>
                )}
                renderInput={(params) => (
                  <TextField
                    placeholder="Tipee para buscar..."
                    {...params}
                    label="Chofer"
                    focused
                    inputProps={{
                      ...params.inputProps,
                    }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth={true}
                focused
                size="small"
                type="date"
                required
                placeholder="Fecha "
                name="fecha_para"
                label="Fecha de Rendicion"
                variant="outlined"
                value={moment(datos.fecha_para).format("YYYY-MM-DD")}
                onChange={almacenar}
              />
            </Grid>
            <Grid item xs={6} display={"flex"} justifyContent={"center"}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={checked}
                    onChange={handleChangeChecked}
                    inputProps={{ "aria-label": "controlled" }}
                  />
                }
                label="Reparto de Tarde"
              />
            </Grid>
          </Grid>
          <Grid
            mt={1}
            container
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Button variant="contained" onClick={() => onClose()} color="error">
              Volver
            </Button>
            <Button
              disabled={
                isLoading ||
                mostrarAdvertencia ||
                !choferSeleccionado ||
                !hojaSeleccionada
              }
              variant="contained"
              onClick={guardarChoferAsignado}
              color="success"
            >
              Guardar
            </Button>
          </Grid>
        </DialogContent>
      </Dialog>
      <Snackbar
        open={notificacion.open}
        autoHideDuration={3000}
        onClose={() => setNotificacion({ ...notificacion, open: false })}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={() => setNotificacion({ ...notificacion, open: false })}
          severity={notificacion.severity}
          sx={{ width: "100%" }}
        >
          {notificacion.mensaje}
        </Alert>
      </Snackbar>
    </>
  );
}

export default AsignarHojaRuta;
